import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../../utils/axiosInstance";
// import axiosInstance from "../../utils/axiosInstance";

export const giftCardUnusedApi = createAsyncThunk(
  "giftCardUnused",
  async ({ startDate = null, endDate = null }) => {
    const params = {};
    if (startDate) params.startDate = startDate;
    if (endDate) params.endDate = endDate;
    const response = await axiosInstance.get("/giftcardc2c", { params });
    return response.data;
  }
);

const giftCardUnusedSlice = createSlice({
  name: "giftCardUnused",
  initialState: {
    giftCardUnused: [],
    errors: [],
    loading: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(giftCardUnusedApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(giftCardUnusedApi.fulfilled, (state, action) => {
        state.giftCardUnused = action.payload;
        state.loading = false;
      })
      .addCase(giftCardUnusedApi.rejected, (state, action) => {
        state.errors.push(action.error.message);
        state.loading = false;
      });
  },
});

export default giftCardUnusedSlice.reducer;
